import React from 'react';
import { JiraLogo, JiraServiceManagementLogo } from '@atlaskit/logo';
import {
	CORE_PROJECT,
	SERVICE_DESK_PROJECT,
	SOFTWARE_PROJECT,
} from '@atlassian/jira-common-constants';

type LogoProps = {
	projectType: typeof SOFTWARE_PROJECT | typeof CORE_PROJECT | typeof SERVICE_DESK_PROJECT;
};

export function Logo(props: LogoProps) {
	const { projectType } = props;

	if (projectType === SOFTWARE_PROJECT || projectType === CORE_PROJECT) {
		return <JiraLogo size="small" appearance="brand" />;
	}
	if (projectType === SERVICE_DESK_PROJECT) {
		return <JiraServiceManagementLogo size="small" appearance="brand" />;
	}
	return null;
}
